import { AttributeDependenciesReadModel } from "@Alternatives/Attributes/Domain/readmodels";

export class AttributeDeleterDialogViewModel
{
    opened: boolean = false;

    attributeId: number | null = null;
    attributeName: string | null = null;
    rm: AttributeDependenciesReadModel | null = null;

    show(attrId: number, attrName: string)
    {
        this.attributeId = attrId;
        this.attributeName = attrName;
        this.rm = null;

        this.opened = true;
    }

    close()
    {
        this.opened = false;
        
        this.attributeId = null;
        this.attributeName = null;
        this.rm = null;
    }


    setData(rm: AttributeDependenciesReadModel)
    {
        this.rm = rm;
    }
}